import React, { useState, useContext, useEffect } from "react";
import DataGrid, { IDataGridOptions, Column, Export } from "devextreme-react/data-grid";
import { String } from "../../../utils/utilities";
import { IAEAGridProps } from "../../../interfaces/ux/aea-grid.interface";
import storeContext from "../../../context/store-context";
import "./aea-grid.scss";
import withLoader from "../HOC/withLoader";
import { Template } from 'devextreme-react/core/template';
import { SelectBox } from "devextreme-react";
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';
import moment from "moment";

const _exportDataGrid = require("devextreme/exporter/exceljs/exportDataGrid");

const { StoreContext } = storeContext;

const AEAGrid: React.FC<IAEAGridProps> = (props: IAEAGridProps) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [yearsSelect, setyearsSelect] = useState({min: null, max: null});

  const onResize = () => {
    setIsMobile(window.innerWidth < 768);
  };
  const context = useContext(StoreContext);

  const onToolbarPreparing = (e: any) => {
    const langData = localStorage.getItem('_sys_current_lang');
    
    const currentLang = langData ? JSON.parse(langData).label : 'ES';
  
    const hintText = currentLang === 'EN' ? 'Add Budget' : 'Agregar Presupuesto';
  
    e.toolbarOptions.items.unshift({
      location: "after",
      widget: "dxButton",
      options: {
        icon: "plus",
        hint: hintText,
      },
      onClick: () => {
        context.history.push(props.newUrl);
      },
    });
  };

  
  const contextMenuPreparing = (e: any) => {
    if (e.target === "content" && props.menuItems) {
      e.items = props.menuItems.map((item) => {
        return {
          ...item,
          onItemClick: () => {
            if (!String.IsNullOrWhiteSpace(item.url)) {
              context.history.push(item.url);
            }
          },
        };
      });
    }
  };

  window.addEventListener("resize", onResize);
  let internalProps: IDataGridOptions = {
    columnChooser: { allowSearch: true, enabled: true, mode: "select" },
    showBorders: true,
    allowColumnResizing: true,
    columnResizingMode: "widget",
    allowColumnReordering: true,
    columnFixing: { enabled: true },
    filterRow: { visible: true, showOperationChooser: true },
    headerFilter: { visible: true, allowSearch: true },
    columnMinWidth: 200,
    sorting: { mode: "multiple" },
    pager: {
      allowedPageSizes: [20, 50, 100],
      visible: true,
      showInfo: true,
      showNavigationButtons: true,
      showPageSizeSelector: true,
    },
    export: { enabled: false },
    rowAlternationEnabled: true,
    hoverStateEnabled: true,
    groupPanel: { visible: true },
    showRowLines: false,
    grouping: {
      contextMenuEnabled: true,
      autoExpandAll: false,
      allowCollapsing: true,
    },
    onContextMenuPreparing: !isMobile ? contextMenuPreparing : null,
    onToolbarPreparing: !isMobile ? onToolbarPreparing : null,
  };

  useEffect(() => {
    if(props.changeRange) props.changeRange(yearsSelect.min, yearsSelect.max, props.dataGridOptions.columns)
    //eslint-disable-next-line
  }, [yearsSelect])


  const toolbarItemRender = () => {
    if(props.yearsRange){
      let items: any = props.yearsRange || []
      let itemsMin = yearsSelect.max ? items.filter((x: number) => x <= yearsSelect.max) : items
      let itemsMax = yearsSelect.min ? items.filter((x: number) => x >= yearsSelect.min) : items
      return (
        <div style={{display:"flex", gap:"10px"}}>
          <SelectBox
              placeholder={props.currentLabels.get("AñoMinDetalle")}
              key="Límite min"
              id="Límite min"
              dataSource={itemsMin}
              value={yearsSelect.min}
              onValueChanged={(e) => setyearsSelect({min:e.value, max:yearsSelect.max})}
          />
          <SelectBox
            placeholder={props.currentLabels.get("AñoMaxDetalle")}
            key="Límite max"
            id="Límite max"
            dataSource={itemsMax}
            value={yearsSelect.max}
            onValueChanged={(e) => setyearsSelect({min:yearsSelect.min, max:e.value})}
          />
        </div>
      )
    }
    
  }

  const onExporting =(e: any) => {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Main sheet');

    const date = new Date();

    _exportDataGrid.exportDataGrid({
      component: e.component,
      worksheet,
      autoFilterEnabled: true,
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `Proa Details ${moment.tz(new Date(),'Europe/Madrid')}.xlsx`);
      });
    });
    e.cancel = true;
  }

  internalProps = { ...internalProps , ...props.dataGridOptions};

  delete internalProps.columns;
  let dataColumns = props.columnsAux ? props.columnsAux : props.dataGridOptions.columns
  return (
    <DataGrid {...internalProps} onExporting={onExporting}>
      {dataColumns.map((column: any, i: number) => (
        <Column
          dataType={"string"}
          key={`dx-aea-grid-col-${i}`}
          {...column}
        ></Column>
      ))}
      <Template name="yearsRange" render={toolbarItemRender} />
      <Export enabled={true} allowExportSelectedData={true} />
    </DataGrid>
  );
};
// export default withLoader(AEAGrid);
export default AEAGrid;
